import { ImageMapper } from './ImageMapper';

const mapImageId = (id) => parseInt(id, 10);

export class ImageIndexedDbRepo {
  constructor(db) {
    this.db = db;
  }

  async getImageDataUrl(id) {
    let image = await this.get(mapImageId(id));
    if (!image) return undefined;
    image = await ImageMapper.mapArrayBufferToDataURL(image.image);
    return image;
  }

  async get(id) {
    return (await this.db.images.where('imageId').equals(id).toArray())[0];
  }

  async saveImage(formId, image, path, questionId, questionType) {
    const blob = await ImageMapper.base64ToBlob(image);
    const arrayBuffer = await ImageMapper.blobToArrayBuffer(blob);
    const item = {
      formId,
      image: arrayBuffer,
      status: 0,
      url: '',
      path,
      questionId,
      questionType,
    };
    const imageId = mapImageId(await this.db.images.add(item));
    await this.db.images.update(imageId, { imageId });
    return imageId;
  }

  async setImageId(id, imageId) {
    this.db.images.update(mapImageId(id), { imageId: mapImageId(imageId) });
  }

  async getImagesIds({ status, formId }) {
    return (
      await this.db.images
        .where({ ...(status !== undefined && { status }), ...(formId !== undefined && { formId }) })
        .toArray()
    ).map((i) => i.imageId);
  }

  async setImageStatus(imageId, status) {
    await this.db.images.where('imageId').equals(mapImageId(imageId)).modify({ status });
  }

  async deleteList(ids) {
    const filteredIds = ids.filter((id) => Boolean(id));
    await this.db.images.where('imageId').anyOf(filteredIds).delete();
  }

  async getImageIdWithFormIdAndPath({ formId, path }) {
    return (await this.db.images.where({ formId, path }).toArray())[0]?.imageId;
  }
}
